import React, { useContext, useEffect, useRef, useState } from 'react'
import Context from '../../context'
import { getPartnersList } from '../../services/ClubeApi'

function SelectPartnerModal() {
  const closeModal = useRef(null)
  const { setPartner } = useContext(Context)
  const [searchStr, setSearchStr] = useState('')
  const [partnerList, setPartnerList] = useState([])
  const [fullPartnerList, setFullPartnerList] = useState([])

  useEffect(() => {
    getPartnersList().then(r => {
      console.log('rrrr', r)
      setFullPartnerList(r)
    })
  }, [])

  const handleSearchInput = value => {
    setSearchStr(value)
    setPartnerList(
      fullPartnerList.filter(item => {
        return item.fantasyName.toLowerCase().includes(value.toLowerCase())
      })
    )
  }

  const handleSelectPartner = id => {
    setPartner(fullPartnerList.find(item => id === item.id))
    setPartnerList([])
    setSearchStr('')
    closeModal.current.click()
  }

  return (
    <div
      className="modal fade"
      id="selectPartnerModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="selectPartnerModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-body">
            <div className="form-group">
              <input
                value={searchStr}
                onChange={e => handleSearchInput(e.target.value)}
                type="text"
                className="form-control"
                id="search"
                placeholder="Parceiro ou Evento"
              />
            </div>

            {partnerList.length > 0 && (
              <div className="form-group partner-select-area">
                {partnerList.map(item => (
                  <li
                    className="item-click"
                    key={item.id}
                    style={{ marginBottom: '10px' }}
                    onClick={() => handleSelectPartner(item.id)}
                    role="presentation"
                  >
                    {item.fantasyName}
                  </li>
                ))}
              </div>
            )}

            <button
              hidden
              ref={closeModal}
              type="button"
              className="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SelectPartnerModal
